<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <v-icon large>mdi-map</v-icon>
      </v-flex>
      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">Welcome to POI Tracker</h1>
        <p class="subheading font-weight-regular">For help poi-tracker@pilviotus.fi</p>
      </v-flex>

      <v-flex mb-5 xs12>
        <v-autocomplete
          :items="maps"
          default=''
          light
          background-color="white"
          rounded
          clearable
          outlined
          placeholder='Seach for map (e.g. Illinsaaren syyskarkelot)'
          @update:search-input='filterMaps'
          auto-select-first
          item-text='name'
          item-value='name'
        ></v-autocomplete>
      </v-flex>
      <v-flex mb-5 xs12>
        <v-layout justify-start justify-space-between wrap>
          <v-flex xs12 sm5 md3 lg3 v-for="map in filtered" :key="map.map" class="ma-2">
            <v-card
              @click='goTo(map.map)'
            >
              <v-card-title>{{map.name}}</v-card-title>
              <v-card-text>{{map.text}}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    filtered: [],
  }),
  mounted() {
    this.$store.dispatch('maps');
  },
  methods: {
    goTo(id) {
      this.$router.push({ name: 'mymap', params: { mapId: id } });
    },
    filterMaps(val) {
      if (val) {
        const re = new RegExp(`${val}`, 'i');
        this.filtered = this.maps.filter(map => re.test(map.name));
      } else {
        this.filtered = this.maps;
      }
    },
  },
  computed: {
    maps() {
      return this.$store.state.maps;
    },
  },
};
</script>
<style scoped>
</style>
